import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/6860c299-4edf-4247-809c-d0a98bc683e6.png" 
              alt="IslaVende" 
              className="h-10 mb-4"
            />
            <p className="text-sm text-cobalt-100">
              El marketplace líder de Puerto Rico. Compra y vende con seguridad total.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-base mb-4">Comprar</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/catalogo" className="text-gray-400 hover:text-white transition-colors">Catálogo</Link></li>
              <li><Link to="/autos" className="text-gray-400 hover:text-white transition-colors">Autos</Link></li>
              <li><Link to="/subastas" className="text-gray-400 hover:text-white transition-colors">Subastas</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-base mb-4">Vender</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/registro" className="text-gray-400 hover:text-white transition-colors">Publicar Artículo</Link></li>
              <li><Link to="/representantes" className="text-gray-400 hover:text-white transition-colors">Ser Representante</Link></li>
              <li><Link to="/dashboard" className="text-gray-400 hover:text-white transition-colors">Mi Dashboard</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-base mb-4">Ayuda</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="mailto:ventas@islavende.com" className="text-gray-400 hover:text-white transition-colors">ventas@islavende.com</a></li>
              <li><Link to="/recuperar-contrasena" className="text-gray-400 hover:text-white transition-colors">Recuperar Contraseña</Link></li>
              <li><Link to="/mis-compras" className="text-gray-400 hover:text-white transition-colors">Mis Compras</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-base mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terminos" className="text-gray-400 hover:text-white transition-colors">Términos y Condiciones</Link></li>
              <li><Link to="/privacidad" className="text-gray-400 hover:text-white transition-colors">Política de Privacidad</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
            <div className="flex items-center space-x-6">
              <div className="flex items-center space-x-2 bg-white/10 px-4 py-2 rounded-lg">
                <i className="ri-shield-check-line text-xl text-emerald-400"></i>
                <span className="text-sm font-medium whitespace-nowrap">Compra Protegida</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 px-4 py-2 rounded-lg">
                <i className="ri-mail-send-line text-xl text-sky-400"></i>
                <span className="text-sm font-medium whitespace-nowrap">Envío USPS a toda la isla</span>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <span className="text-sm text-cobalt-100">Métodos de pago:</span>
              <div className="flex items-center space-x-3 bg-white px-4 py-2 rounded-lg">
                <img src="https://public.readdy.ai/ai/img_res/fefcb387a0de15ad28d32884653d7c43.jpg" alt="ATH Móvil" className="h-5" />
                <img src="https://readdy.ai/api/search-image?query=Stripe%20payment%20logo%20simple%20clean%20icon%20on%20white%20background%20professional%20payment%20processor%20brand%20mark&width=60&height=30&seq=stripe1&orientation=landscape" alt="Stripe" className="h-5" />
                <img src="https://readdy.ai/api/search-image?query=Visa%20credit%20card%20logo%20blue%20and%20white%20simple%20clean%20payment%20icon%20on%20white%20background%20official%20brand&width=50&height=30&seq=visa1&orientation=landscape" alt="Visa" className="h-5" />
                <img src="https://readdy.ai/api/search-image?query=Mastercard%20logo%20red%20and%20orange%20circles%20payment%20icon%20simple%20clean%20design%20on%20white%20background%20official%20brand&width=50&height=30&seq=mc1&orientation=landscape" alt="Mastercard" className="h-5" />
              </div>
            </div>
          </div>

          <div className="mt-8 text-center text-sm text-gray-500 space-y-2">
            <p>&copy; {currentYear} IslaVende. Todos los derechos reservados. Hecho con <i className="ri-heart-fill text-red-400"></i> en Puerto Rico.</p>
            <div className="flex items-center justify-center gap-4 flex-wrap">
              <Link to="/terminos" className="hover:text-gray-300 transition-colors">Términos y Condiciones</Link>
              <span className="text-gray-700">·</span>
              <Link to="/privacidad" className="hover:text-gray-300 transition-colors">Política de Privacidad</Link>
              <span className="text-gray-700">·</span>
              <a href="mailto:ventas@islavende.com" className="hover:text-gray-300 transition-colors">ventas@islavende.com</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;